import { type CreditCardVendorEnum } from '@webapp/core/entities/external/CreditCardVendor'
import {
  Currency,
  type CurrencyConstructor,
} from '@webapp/core/entities/external/Currency'
import {
  CreditCardAssignee,
  type CreditCardAssigneeConstructor,
} from '../CreditCardAssignee'

// Minimal vendor reference — provider display + payment-method fetch on the
// bill page. Local value object, not a standalone entity.
interface CreditCardVendorRef {
  id: number
  name: string
}

export interface CreditCardAccountConstructor {
  id: number
  name: string
  number: string // raw card number suffix from API; masked for display
  type: CreditCardVendorEnum
  currency: CurrencyConstructor
  vendor: CreditCardVendorRef
  glCode: string
  assignees: CreditCardAssigneeConstructor[]
}

export class CreditCardAccount {
  readonly id: number
  readonly name: string
  readonly number: string
  readonly type: CreditCardVendorEnum
  readonly currency: Currency
  readonly vendor: CreditCardVendorRef
  readonly glCode: string
  readonly assignees: CreditCardAssignee[]

  constructor(data: CreditCardAccountConstructor) {
    this.id = data.id
    this.name = data.name
    this.number = data.number
    this.type = data.type
    this.currency = new Currency(data.currency)
    this.vendor = data.vendor
    this.glCode = data.glCode
    this.assignees = data.assignees.map(
      (assignee) => new CreditCardAssignee(assignee)
    )
  }

  // "•••• 5978" — client masks the raw number (BHV-001)
  get maskedNumber(): string {
    return `•••• ${this.number.slice(-4)}`
  }

  // Assigned-user count on settings list rows (BHV-009)
  get assigneeCount(): number {
    return this.assignees.length
  }
}
